class Elementor_Carousel {
    static setupData(data) {
        // if (!data.items_margin) {
        //     data.items_margin = 0;
        // }
        //alert(data.items_margin);

        switch (data.navigation) {
            case 'both':
                data.dots = true;
                data.nav = true;
                break;
            case 'arrows':
                data.dots = false;
                data.nav = true;
                break;
            case 'dots':
                data.dots = true;
                data.nav = false;
                break;
            case 'none':
                data.dots = false;
                data.nav = false;
                break;
        }

        data.responsive = {

            0: {
                items: data.items_mobile,
                margin: data.items_margin,
            },
            768: {
                items: data.items_tablet,
                margin: data.items_margin,
            },
            1024: {
                items: data.items,
                margin: data.items_margin,

            }
        }

        if(jQuery('body').hasClass('rtl')){
            data.rtl = true;
        }

        return data;
    }
}